import type { Biller } from './billPresentmentTypes';

export function extractHostname(biller: Biller) {
  if (!biller) return '';

  const url = biller.url || '';

  let hostname;
  // find & remove protocol (http, ftp, etc.) and get hostname
  if (url.indexOf('//') > -1) {
    hostname = url.split('/')[2];
  } else {
    hostname = url.split('/')[0];
  }
  // find & remove any port number
  hostname = hostname.split(':')[0];
  // find & remove any query "?"
  hostname = hostname.split('?')[0];
  // find & remove any beginning www.
  if (hostname.indexOf('www.') === 0) {
    hostname = hostname.slice(4);
  }
  return hostname;
}
